import { CARGAR_ASIENTOCONT } from './actionTypes';
import { VISUALIZAR_LOADING, VISUALIZAR_ALERTA } from '../generales/actionTypes';
import global_axios from '../../funciones_globales/interaccionapi';

export const cargarAsiento = (asientoId) => {
	return (dispatch) => {
		let config_request = {
			method: 'GET',
			url: '/diarios/' + asientoId
		}
		dispatch({
			type: VISUALIZAR_LOADING,
			isVisibleLoading: true
		});
		return global_axios(config_request)
		.then( response => {
			let asientoContable = response.data;		
			dispatch({
				type: CARGAR_ASIENTOCONT,
				data: asientoContable
			});
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
		})
		.catch((error)=>{
			let msgError = error.response?error.response.data.msg:error.message;
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
			dispatch({
				type: VISUALIZAR_ALERTA,
				data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar asiento contable', mensaje: msgError}
			});
		})
	}
}
